import { create } from "zustand";
import { createJSONStorage, devtools, persist } from "zustand/middleware";
import { journeyStorage, journeyStorageKey } from "../utilities/session-storage.ts";
import { isRecord } from "../utilities/signup-lookup.ts";

export interface OnboardingData {
	energy: "electricity" | "gas";
	isCommercial: boolean;
	address: { [key: string]: any }; // structure  address from experian TODO:// maybe type this better
	nmi?: string;
	promoCode?: string;
	productType?: string;
	plan?: { [key: string]: any };
	aseXML?: string;
	installationTypeCode?: string;
}

type OnboardingStore = {
	data: OnboardingData | null;
	hasHydrated: boolean;
	setOnboardingData: (data: OnboardingData) => void;
	clearOnboardingData: () => void;
	setHasHydrated: (hydrated: boolean) => void;
};

export const useOnboardingStore = create<OnboardingStore>()(
	devtools(
		persist(
			set => ({
				data: null,
				hasHydrated: false,
				setOnboardingData: data => set({ data }),
				clearOnboardingData: () => set({ data: null }),
				setHasHydrated: hydrated => set({ hasHydrated: hydrated }),
			}),
			{
				name: journeyStorageKey("solstice-onboarding-store"),
				storage: createJSONStorage(() => journeyStorage),
				skipHydration: true,
				partialize: state => ({ data: state.data }),
				merge: (persisted, current) => {
					const data = isRecord(persisted) ? persisted.data : null;
					return {
						...current,
						data:
							isRecord(data) &&
							(data.energy === "electricity" || data.energy === "gas") &&
							typeof data.isCommercial === "boolean" &&
							isRecord(data.address) &&
							isRecord(data.plan)
								? (data as unknown as OnboardingData)
								: null,
					};
				},
			},
		),
		{ enabled: process.env.NODE_ENV === "development" },
	),
);
